import React, { useState, useRef } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useClickOutside } from '@/hooks/useClickOutside';
import { UserDropdown } from './UserDropdown';
import styles from './UserArea.module.scss';
import LoginPopup from './LoginPopup';
import type { IUserWrapper } from '@/stores/currentUserApi';

export const UserArea = ({ user }: { user?: IUserWrapper }) => {
  const { t } = useTranslation();

  const [showLogin, setShowLogin] = useState(false);
  const loginRef = useRef(null);
  useClickOutside(loginRef, () => {
    setShowLogin(false);
  });

  const toggleLoginPopup = () => {
    setShowLogin(!showLogin);
  };

  return (
    <div ref={loginRef}>
      {user ? (
        <UserDropdown user={user} />
      ) : (
        <button
          className={`btn btn-link d-flex ${styles.dropdownToggle}`}
          aria-haspopup="true"
          aria-expanded={showLogin}
          data-toggle="dropdown"
          type="button"
          onClick={toggleLoginPopup}
        >
          <span className={`${styles.userName} text-sans-serif`}>
            <span className="fa fa-user mr-2"></span>
            {t('common:actions.login')}
          </span>
        </button>
      )}

      {showLogin && !user && (
        <div className={styles.loginPopup}>
          <LoginPopup />
        </div>
      )}
    </div>
  );
};
